import { render, staticRenderFns } from "./TrainingPlanForm.vue?vue&type=template&id=84eadd12&"
import script from "./TrainingPlanForm.vue?vue&type=script&lang=js&"
export * from "./TrainingPlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports